<div class="center-align" [class.no-content-spacer]="padSpace">
  <div [class.mat-display-1]="!compact" [class.mat-h2]="compact">{{title}}</div>
  <div [class.mat-body-1]="compact" class="text-disabled-color">{{details}}</div>

  <ng-content></ng-content>
</div>
